import { STATIC_FRONTEND_MODE, getApiUnavailableMessage } from "@/lib/backend";

export default function BackendServiceNotice({ className = "", compact = false }) {
  if (!STATIC_FRONTEND_MODE) return null;

  const message = getApiUnavailableMessage();

  return (
    <div
      role="status"
      data-testid="backend-service-notice"
      className={`rounded-xl border border-amber-400/25 bg-amber-400/10 text-amber-100/90 ${
        compact ? "px-4 py-3 text-xs leading-relaxed" : "px-4 py-3.5 text-sm leading-relaxed"
      } ${className}`}
    >
      {message}
    </div>
  );
}
